<template>
  <div>
    <div class="el-upload-list--picture-card file_list">
      <div v-for="(file, index) in fileList"
            :key="file.url"
            style="display: inline-block;">
        <div class="el-upload-list__item is-ready">
          <img class="el-upload-list__item-thumbnail" v-if="wordExtensions.some(ext => file.url.toLowerCase().endsWith(ext))" src="../assets/images/word.png">
          <img class="el-upload-list__item-thumbnail" v-else-if="excelExtensions.some(ext => file.url.toLowerCase().endsWith(ext))" src="../assets/images/excel.png">
          <img class="el-upload-list__item-thumbnail" v-else-if="/\.pdf$/.test(file.url.toLowerCase())" src="../assets/images/pdf.png">
          <img
            v-else
            :id="file.url"
            class="el-upload-list__item-thumbnail"
            :onerror="errImage"
            :src="file.url" alt=""
          >
        </div>
        <p class="file_name" @click="handlePictureCardPreview(file, index)">{{file.name}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    showAdd: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fileList: {
      type: Array,
      default () {
        return []
      }
    },
    clientId: { // 委托方ID
      type: Number,
      required: false
    },
    kernelId: {     // 核心单据ID(订单ID)
      type: Number,
      default: 0,
      required: false
    },
    billsId: {      // 关联单据ID(当前单据ID)
      type: [Number, String],
      default: 0 // 测试数据1111、1112、1113
    },
    billType: { // 单据类型
      type: String
    }
  },
  data () {
    return {
      wordExtensions: ['.doc', '.docx', '.docm', '.dot', '.dotx', '.dotm'],
      excelExtensions: ['.xls', '.xlsx', '.xlsm', '.xlsb', '.xlt', '.xltx', '.xltm'],
      imageExtensions: ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.tiff', '.tif', '.heic', '.heif', '.ico', '.svg'],
      dialogImageUrl: '',
      errImage: 'this.src="' + require('../assets/images/file.png') + '"', // 缩略图未加载时显示的默认图片
    }
  },
  computed: {},
  created () { },
  mounted () { },
  watch: {},
  methods: {
    // 自定义图片上传
    uploadFn (item) {
      let formData = new FormData()
      formData.append('file', item.file)                       // 上传文件
      formData.append('alias', item.file.name)                 // 文件别名
      formData.append('folderId', 1) // 文件夹id
      formData.append('kernelId', (this.kernelId || 0))             // 核心单据id
      formData.append('billsId', this.billsId)                // 关联单据id
      formData.append('billType', this.billType)
      this.$http({
        url: item.action,
        method: 'post',
        data: formData,
        timeout: 1000 * 60 * 10
      }).then(res => {
        if (res.data.code === 'C0000') {
          this.$message.success('附件上传成功')
          this.fileList.push({
            name: item.file.name,
            url: res.data.result
          })
        } else {
          this.$message.error(res.data.message)
        }
      }).catch(() => {
        this.$message.error('附件上传请求失败')
      })
    },
    // 附件上传前触发，验证上传附件
    beforeAvatarUpload (file) {
      const isLt100M = file.size / 1024 / 1024 < 100
      const isLt100 = file.name.length < 100

      if (!isLt100M) {
        this.$message.error('上传附件大小不能超过 100MB!')
      }

      if (!isLt100) {
        this.$message.error('上传附件名称不能超过 100字符!')
      }
      return isLt100M && isLt100
    },
    handlePictureCardPreview(file, i) {
      // if (this.imageExtensions.some(ext => file.url.toLowerCase().endsWith(ext))) {
        // this.$nextTick(() => {
        //   const $viewer = viewerApi({
        //     options: {
        //       initialViewIndex: i,
        //       zIndex: 9999,
        //     },
        //     images: this.fileList.map(item => item.url),
        //   });
        // })
      // } else {
        this.handleDownload(file)
      // }
    },
    handleDownload(file) {
      let eleLink = document.createElement('a')   // 创建隐藏的可下载链接
      eleLink.download = ''
      eleLink.style.display = 'none'
      eleLink.href = file.url
      eleLink.target = '_blank'
      document.body.appendChild(eleLink)
      eleLink.click()                                // 触发点击
      document.body.removeChild(eleLink)            // 移除标签
    },
    handleRemove(file,index) {
      this.fileList.splice(index,1)
    },
  }
}
</script>

<style lang="less" scope>
.file_list{
  display: flex;
  flex-wrap: wrap;
  .file_name{
    color: #0068b7;
    line-height: 28px;
    font-size: 24px;
    text-align: center;
    width: 300px;
    margin: 0;
    margin-bottom: 10px;
  }
}
</style>
